// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2T9ay","list":"styles_list__1_dZw"};